import api from '../index'

let header = {
    belong : "bulletin"
}
export default {
    getMonthScheduleList(params){
        return api.post('/portal/schedule/selectMonthScheduleList',params, header)
    },
    getCurrSchedule(params){
        return api.post('/portal/schedule/select',params, header)
    },
    getScheduleIdDetail(params){
        return api.get(`/portal/schedule/${params.scheduleId}`,{}, header)
    },
    getTree(){
        return api.get(`/schedule/extend/userTree`,{}, {
            belong: 'schedule'
        })
        // return api.get('https://dolphin.j0.test.nill.work/x/auth-server/api/smartMedia/getSubsystem', {}, header)
    },
    insertSchedule(params){ 
        return api.post('/portal/schedule/insert',params,header)
    },
    updateSchedule(params){
        return api.post('/portal/schedule/update',params,header)
    },
    deleSchedule(scheduleId){
        return api.get(`/portal/schedule/delete/${scheduleId}`,{},header)
    },
    updateScheduleState(params){ //更新日程状态
        return api.post(`/portal/schedule/updateScheduleState`, params,header)
    },
    scheduleSeparateRemind(params){
        return api.post('/portal/schedule/singleRemind',params,header)
    },
    // 立刻提醒
    immediatelyRemind(params){
        return api.get(`/portal/schedule/forthwithRemind/${params.scheduleId}`,params,header)
    },
    // 全天选择枚举列表
    getSelectFullDayList(params){
        return api.get(`/portal/schedule/extend/select/full/day`,params,header)
    },
    // 非全天选择枚举列表
    getSelectIntervalDayList(params){
        return api.get(`/portal/schedule/extend/select/interval/day`,params,header)
    },
    // 重复选择枚举列表
    getSelectRepeatList(params){
        return api.get(`/portal/schedule/extend/select/repeat`,params,header)
    },
}